module.exports = __webpack_public_path__ + "img/logobranco_comslogan_pequeno_final.90aa6034.png";